import { CapacitorHttp } from "@capacitor/core";
export * from './graph-db/generated/schema';
import { create_graphdb_client } from "./graph-db";


export const graphdb = create_graphdb_client({
   storage: 'capacitor',
   requested_role: 'seller',
   auth_endpoint: import.meta.env.VITE_AUTH_ENDPOINT,
   graph_endpoint: import.meta.env.VITE_GRAPHQL_ENDPOINT,
   graph_ws_endpoint: import.meta.env.VITE_GRAPHQL_WS_ENDPOINT,
   fetch_function: async ({ url, access_token, body, clean_object }) => {
      const fetch_options = clean_object({
         url,
         headers: {
            'Content-Type': 'application/json',
            Authorization: access_token ? `Bearer ${access_token}` : undefined
         },
         data: body ? JSON.stringify(body) : undefined
      });
      // console.log({ fetch_options, url, access_token, body });

      const response = await CapacitorHttp.post(fetch_options);
      // console.log({ response });

      return response.data ?? null;
   },
})